import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

import { getCryptoPwd } from '@/utils/crypto';
/**
 * 随机生成唯一的节点ID
 * @returns
 */
export const getNodeId = (index?: number) => {
  const uuid = uuidv4();
  const timestamp = dayjs().valueOf(); // 使用纳秒级时间戳提高唯一性
  const localPath = getCryptoPwd(`${uuid}-${timestamp}_${index ?? ''}`);
  return localPath;
};

export const getShortUuid = () => {
  const uuid = uuidv4();
  return uuid.split('-')[0];
};
